<!-- O componente PFiltro constroi a tela de filtro de acordo com os valores passados para a props filterTypes. Nessa variável podemos passar alguns tipos de filtros
  como 'integer', o qual tera um campo de text que podemos informar valores com '-' ou ',' "Exemplo: 1-3,4-9,10", e quando tiver a ',' será separação e quando estiver '-'
  será valores continuos. Também temos o tipo 'string' que funciona estilo o like do sql. O tipo 'date' ou 'datetime' os quais possuem dois campo um para início e outro para fim
   filtrando as datas no periodo selecionado nos campos(inicio e fim). Tipo 'array' o qual devemos informar uma lista de valores os quais o usuario podera selecionar quantos
   ele quiser e o filtro será feito de acordo com os campos selecionados. E por fim o tipo boolean, o qual possui um campo de marcar, que quando estiver marcado, irá filtrar apenas
   os registros que estão com o valor true-->
<template>
  <div class="filter" ref='pfilter' :id="entity ? `filter_${entity}` : 'filter'">
    <v-btn style="margin-top: 0; margin-bottom: 0" outline :disabled="disabled" :loading="!filterItensLoaded" @click="activator" color="primary">Filtro</v-btn>
    <v-dialog v-model="dialogFilter" persistent scrollable max-width="900px">
      <v-card style="word-break: break-all;">
        <v-card-title primary-title class="filter-card-title">
          <span class="headline">Preencha seu filtro</span>
          <v-tooltip v-if="info" top style="padding-bottom: 50px">
            <v-icon slot="activator" color="black">info</v-icon>
            <span>{{info}}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 900px;">
          <v-form @keyup.native.esc="close" @keyup.native.enter="customFilter(null, postFilter, doFilter)">
            <!--//os campos sao montados dinamicamente atravez dos types, que é um props-->
            <v-flex xs12 v-for="(type, index) in localFilterType" :key="index">
              <!--//campo integer-->
              <v-flex v-if="type.type === 'integer'">
                <v-text-field :disabled="type.disabled" :hint='type.hint || "Exemplo: 1-3,4-9,10"' :label="type.label ? type.label : translate('table.' + entity + '.field.' + type.field)" :name="'pf_' + type.field" :id="'pf_' + type.field"
                              v-model="filter[type.field]" data-vv-delay="1000"
                ></v-text-field>
              </v-flex>
              <!--//campo string-->
              <v-flex v-else-if="type.type === 'string'">
                <v-text-field :disabled="type.disabled" :hint='type.hint || ""' :label="type.label ? type.label : translate('table.' + entity + '.field.' + type.field)" :name="type.field" :id="'pf_' + type.field"
                              v-model="filter[type.field]" data-vv-delay="1000"
                ></v-text-field>
              </v-flex>
              <!--//campo date-->
              <v-flex v-else-if="type.type === 'date'">
                <v-select
                clearable
                :items="dateFilterItems"
                :label="type.label ? type.label : translate('table.' + entity + '.field.'+ type.field)"
                v-model="filter[type.field+'_period']"
                :disabled="type.disabled"
                @input="(val) => {changePeriodType(val, type.field, false)}"
                >
                <template slot='selection' slot-scope='{ item }'>
                  {{ item.text !== 'Período' ? item.text : `${filter[type.field+'_end'] ? '' : 'Desde '}${filter[type.field+'_begin'] ? moment(filter[type.field+'_begin']).format('DD/MM/YYYY') : ''} ${filter[type.field+'_end'] ? 'Até ' + moment(filter[type.field+'_end']).format('DD/MM/YYYY') : ''}`}}
                </template>
                </v-select>
              </v-flex>
              <!--//campo datetime-->
              <v-flex v-else-if="type.type === 'datetime'">
                <v-select
                clearable
                :items="dateFilterItems"
                :label="type.label ? type.label : translate('table.' + entity + '.field.'+ type.field)"
                v-model="filter[type.field+'_period']"
                :disabled="type.disabled"
                @input="(val) => {changePeriodType(val, type.field, true)}"
                >
                <template slot='selection' slot-scope='{ item }'>
                  {{ item.text !== 'Período' ? item.text : `${filter[type.field+'_end'] ? '' : 'Desde '}${filter[type.field+'_begin'] ? moment(filter[type.field+'_begin']).format('DD/MM/YYYY HH:mm') : ''} ${filter[type.field+'_end'] ? 'Até ' + moment(filter[type.field+'_end']).format('DD/MM/YYYY HH:mm') : ''}`}}
                </template>
                </v-select>
              </v-flex>
              <!--//campo array-->
              <v-flex v-else-if="type.type === 'array'">
                <v-autocomplete :id="'pf_' + type.field" :name="'pf_' + type.field" :disabled="type.disabled" multiple :label="type.label ? type.label : translate('table.' + entity + '.field.' + type.field)" :filter="filterAutocomplete"
                                v-model="filter[type.field]" data-vv-delay="1000" :items="type.items" :loading="type.loading" @blur="$emit('blur_' + type.field, filter[type.field])" :item-text="type.text||'text'" :item-value="type.value||'value'"
                ></v-autocomplete>
              </v-flex>
              <!--//campo boolean-->
              <v-flex v-else-if="type.type === 'boolean'">
                <v-switch :id="'pf_' + type.field" :disabled="type.disabled" :label="type.label ? type.label : translate('table.' + entity + '.field.' + type.field)" :name="type.field"
                          v-model="filter[type.field]">
                </v-switch>
              </v-flex>
            </v-flex>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="filter_filter_btn" class="mx-0" color="primary darken-2" @click="customFilter(null, postFilter, doFilter)">Filtrar</v-btn>
          <v-btn id="filter_close_btn" class="mx-0" @click="close">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--<v-flex xs12>-->
    <div v-show="!disabled">
      <span v-if="filterHeigth < 50" >
        <v-tooltip bottom v-for="(value, index) in chips" :key="index">
          <v-chip
            slot="activator"
            @input="deleteChip(value.name)"
            text-color="primary"
            :close="value.disabled !== true && value['not_close'] !== true"
            color="green"
            outline
          >{{value.title}}
          </v-chip>
          <span>{{value.values}}</span>
        </v-tooltip>
      </span>
      <span v-else>
        <v-btn id="showChip" small text-color="primary" color="green" outline round @click="showMoreFilters = !showMoreFilters">
          <span>Mostrar filtros...</span>
        </v-btn>
        <v-tooltip :attach="'#showChip'" bottom v-model="showMoreFilters">
          <v-card>
            <v-flex xs12>
              <v-tooltip bottom>
                <v-btn flat icon align-end color="#000" slot="activator">
                  <v-icon>close</v-icon>
                </v-btn>
                <span>Fechar</span>
              </v-tooltip>
            </v-flex>
            <v-tooltip bottom v-for="(value, index) in chips" :key="index">
              <v-chip
                slot="activator"
                @input="deleteChip(value.name)"
                text-color="primary"
                :close="value.disabled !== true && value['not_close'] !== true"
                color="green"
                outline
              >{{value.title}}
              </v-chip>
              <span>{{value.values}}</span>
            </v-tooltip>
          </v-card>
        </v-tooltip>
      </span>
    </div>
    <p-period-dialog
    :dialog="periodDialog"
    @change="val => {periodChangeProcess(val)}"
    @close="() => {periodDialog = false}"
    :dateTime="isDateTime"
    :title="dialogTitle"
    ></p-period-dialog>
  </div>

</template>

<style scoped>
  .filter-card-title{
    display: flex;
    justify-content: space-between;
  }
  .filter{
    display: flex;
    flex-wrap: wrap;
  }
</style>

<script>
  import PDate from './../shared/PDate'
  import PDateTime from './../shared/PDateTime'
  import PPeriodDialog from './../shared/PPeriodDialog'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'

  momentDurationFormatSetup(moment)
  export default {
    data: () => ({
      localFilterType: [],
      chips: [],
      filter: {},
      periodDialog: false,
      dateFilterItems: [{value: 'Diária', text: 'Diária'}, {value: 'Semanal', text: 'Semanal'}, {value: 'Mensal', text: 'Mensal'}, {value: 'Período', text: 'Período'}],
      isDateTime: false,
      dialogTitle: '',
      tempField: '',
      oldFilter: {},
      filterHeigth: 0,
      userFilter: {},
      items: {},
      dialogFilter: false,
      showMoreFilters: false,
      firstTime: true
    }),
    components: {PDate, PDateTime, PPeriodDialog},
    props: {
      // doFilter verificará se é necessário fazer o filtro dos itens e já retorná-los então
      doFilter: true,
      postFilter: true,
      entity: '',
      allItems: {
        default: []
      },
      disabled: {
        type: Boolean,
        default: false
      },
      filterItensLoaded: {
        type: Boolean,
        default: true
      },
      info: null,
      filterTypes: {}
    },
    watch: {
      dialogFilter (val) {
        if (val) {
          this.reloadLocalFilterType()
        }
      },
      filterTypes (val) {
        this.reloadLocalFilterType()
      }
    },
    methods: {
      changePeriodType (val, tempField, datetime) {
        if (val === 'Período') {
          this.tempField = tempField
          this.isDateTime = datetime
          this.dialogTitle = this.translate('table.' + this.entity + '.field.' + tempField)
          this.periodDialog = true
        } else {
          this.dateFilterItems[3].text = 'Período'
          delete this.filter[tempField + '_begin']
          delete this.filter[tempField + '_end']
        }
      },
      periodChangeProcess (val) {
        this.filter[this.tempField + '_begin'] = val.begin
        this.filter[this.tempField + '_end'] = val.end
        // this.dateFilterItems[3].text = `${val.end ? '' : 'Desde '}${val.begin ? moment(val.begin).format(this.isDateTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY') : ''} ${val.end ? 'Até ' + moment(val.end).format(this.isDateTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY') : ''}`
      },
      activator () {
        this.$emit('clickActivator')
        this.dialogFilter = true
      },
      deleteChip (val) {
        val.forEach((res) => {
          this.filter[res] = ''
        })
        this.customFilter(null, this.postFilter, this.doFilter)
      },
      filterAutocomplete (item, queryText, itemText) {
        const hasValue = val => val != null ? val : ''
        const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const query = hasValue(queryText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return text.indexOf(query) > -1
      },
      mountChips: function () {
        this.chips = []
        let name = []
        this.filterHeigth = 0
        this.localFilterType.forEach((type) => {
          name = []
          switch (type.type) {
            case 'integer':
              if (this.filter[type.field] && (this.filter[type.field] !== '')) {
                name.push(type.field)
                this.chips.push({
                  title: type.label ? type.label : this.translate('table.' + this.entity + '.field.' + type.field),
                  values: this.filter[type.field],
                  disabled: type.disabled,
                  not_close: type['not_close'],
                  name: name
                })
              }
              break
            case 'string':
              if (this.filter[type.field] && (this.filter[type.field] !== '')) {
                name.push(type.field)
                this.chips.push({
                  title: type.label ? type.label : this.translate('table.' + this.entity + '.field.' + type.field),
                  values: this.filter[type.field],
                  disabled: type.disabled,
                  not_close: type['not_close'],
                  name: name
                })
              }
              break
            case 'date':
              let valuesDate = ''
              if ((this.filter[type.field + '_period']) && (this.filter[type.field + '_period'] !== '') && this.filter[type.field + '_period'] !== 'Período') {
                valuesDate = this.filter[type.field + '_period']
                name.push(type.field + '_period')
              } else {
                if ((this.filter[type.field + '_begin']) && (this.filter[type.field + '_begin'] !== '')) {
                  name.push(type.field + '_begin')
                  valuesDate = `${this.filter[type.field + '_end'] && (this.filter[type.field + '_end'] !== '') ? '' : 'Desde '}` + moment(this.filter[type.field + '_begin']).format('DD/MM/YYYY')
                }
                if (this.filter[type.field + '_end'] && (this.filter[type.field + '_end'] !== '')) {
                  valuesDate = valuesDate + ' Até ' + moment(this.filter[type.field + '_end']).format('DD/MM/YYYY')
                  name.push(type.field + '_end')
                }
                name.push(type.field + '_period')
              }
              if (valuesDate !== '') {
                this.chips.push({
                  title: type.label ? type.label : this.translate('table.' + this.entity + '.field.' + type.field),
                  values: valuesDate,
                  disabled: type.disabled,
                  not_close: type['not_close'],
                  name: name
                })
              }
              break
            case 'datetime':
              let valuesDateTime = ''
              if ((this.filter[type.field + '_period']) && (this.filter[type.field + '_period'] !== '') && this.filter[type.field + '_period'] !== 'Período') {
                valuesDateTime = this.filter[type.field + '_period']
                name.push(type.field + '_period')
              } else {
                if ((this.filter[type.field + '_begin']) && (this.filter[type.field + '_begin'] !== '')) {
                  name.push(type.field + '_begin')
                  valuesDateTime = `${this.filter[type.field + '_end'] && (this.filter[type.field + '_end'] !== '') ? '' : 'Desde '}` + moment(this.filter[type.field + '_begin']).format('DD/MM/YYYY HH:mm')
                }
                if (this.filter[type.field + '_end'] && (this.filter[type.field + '_end'] !== '')) {
                  valuesDateTime = valuesDateTime + ' Até ' + moment(this.filter[type.field + '_end']).format('DD/MM/YYYY HH:mm')
                  name.push(type.field + '_end')
                }
                name.push(type.field + '_period')
              }
              if (valuesDateTime !== '') {
                this.chips.push({
                  title: type.label ? type.label : this.translate('table.' + this.entity + '.field.' + type.field),
                  values: valuesDateTime,
                  disabled: type.disabled,
                  not_close: type['not_close'],
                  name: name
                })
              }
              break
            case 'boolean':
              if (this.filter[type.field] && (this.filter[type.field] !== '')) {
                name.push(type.field)
                this.chips.push({
                  title: type.label ? type.label : this.translate('table.' + this.entity + '.field.' + type.field),
                  values: this.filter[type.field] ? 'Marcado' : 'Desmarcado',
                  disabled: type.disabled,
                  not_close: type['not_close'],
                  name: name
                })
              }
              break
            case 'array':
              if (this.filter[type.field] && (this.filter[type.field] !== '') && (this.filter[type.field].length > 0)) {
                // usado o map para percorrer os items selecionados no filtro e colocar na variavel values o id_text e não o id normal
                let values = ''
                name.push(type.field)
                if (type.items) {
                  this.filter[type.field].map((val) => {
                    let item = type.items.find((res) => {
                      return res[type.value || 'value'] === val
                    })
                    item = item ? item[type.text || 'text'] : ''
                    values = values + (values === '' ? '' : ', ') + item
                  })
                }
                if (values !== '') {
                  this.chips.push({
                    title: type.label ? type.label : this.translate('table.' + this.entity + '.field.' + type.field),
                    values: values,
                    disabled: type.disabled,
                    not_close: type['not_close'],
                    name: name
                  })
                }
              }
              break
          }
        })
        // setTimeout incluido para dar tempo de passar pelo for acima e criar todos o chips
        setTimeout(() => {
          this.filterHeigth = this.$refs.pfilter.offsetHeight
        }, 500)
      },
      customFilter: function (items = null, postFilter = true, doFilter = true) {
        let filteredItems = []
        // usado para alterar o valor do filters(usado na dashboard)
        this.$emit('beforeCustomFilter')
        if (doFilter) {
          let result = true
          this.oldFilter = JSON.parse(JSON.stringify(this.filter))
          // Usado para preencher quando entra na tela
          this.reloadLocalFilterType()
          // Possibilita passar os proprios valores pela função. Necessário pois na chamada do customFilter no Initialize do crud o allItems ainda não recebeu os valores.
          this.items = items || this.allItems
          // Para fazer o filtro incia fazendo um filtro do allItems que são todos os itens da tabela e no filtro se verifica quais foram os
          // filtros preenchidos e faz o devido filtro de acordo com o tipo dele
          filteredItems = this.items.filter(obj => {
            result = true
            this.localFilterType.forEach((type) => {
              let now = this.moment()
              switch (type.type) {
                case 'integer':
                  if (this.filter[type.field] && (this.filter[type.field] !== '')) {
                    // Primeiro é feito um split do ',' para pegar todos os conjuntos separados, exemplo('1-3,4,2' => '[1-3],[4],[2]') e para cada conjunto separara por '-' para poder pegar
                    // os valores exatos, caso tenha algum '-' irá considerar como se fosse continuo exemplo([1-3] então será (1,2,3), caso não tenha nenhum '-',
                    // comparará apenas com o valor
                    let stopping = String(this.filter[type.field]).split(',')
                    let continuous = []
                    result = false
                    stopping.forEach((item) => {
                      continuous = item.split('-')
                      if (continuous.length > 1) {
                        if ((parseInt(obj[type.field]) >= parseInt(continuous[0])) && (parseInt(obj[type.field]) <= parseInt(continuous[1]))) {
                          result = true
                        }
                      } else {
                        if ((parseInt(obj[type.field]) === parseInt(continuous[0]))) {
                          result = true
                        }
                      }
                    })
                  }
                  break
                case 'string':
                  // É usado o indexOf para que o filtro funcione igual ao like no SQL
                  // É usado o normalize com o replace para substituir os caracteres com acentuação
                  // this.filter[type.field] + '' concatena com o '' pois as vezes não vem string, e quando concatena transforma em string
                  if (this.filter[type.field] && (this.filter[type.field] !== '') && ((obj[type.field] === null) || (((obj[type.field].toUpperCase()).normalize('NFD').replace(/[\u0300-\u036f]/g, '')).indexOf(((this.filter[type.field] + '').toUpperCase()).normalize('NFD').replace(/[\u0300-\u036f]/g, '')) === -1))) {
                    result = false
                  }
                  break
                case 'datetime':
                  // MOment foi usado pois quando vinha o obj[type.field]) sem os segundos estava dizendo que ele era menor que o this.filter[type.field +] apesar de serem iguais
                  if (this.filter[type.field + '_period'] === 'Diária') {
                    if (!obj[type.field] || moment(obj[type.field]).isBefore(now.startOf('day')) || moment(obj[type.field]).isAfter(now.endOf('day'))) {
                      result = false
                    }
                  } else if (this.filter[type.field + '_period'] === 'Semanal') {
                    if (!obj[type.field] || moment(obj[type.field]).isBefore(now.startOf('week')) || moment(obj[type.field]).isAfter(now.endOf('week'))) {
                      result = false
                    }
                  } else if (this.filter[type.field + '_period'] === 'Mensal') {
                    if (!obj[type.field] || moment(obj[type.field]).isBefore(now.startOf('month')) || moment(obj[type.field]).isAfter(now.endOf('month'))) {
                      result = false
                    }
                  } else {
                    if ((this.filter[type.field + '_begin'] && (this.filter[type.field + '_begin'] !== '') && !(moment(obj[type.field]).isAfter(moment(this.filter[type.field + '_begin']))))) {
                      result = false
                    }
                    if (this.filter[type.field + '_end'] && (this.filter[type.field + '_end'] !== '') && !(moment(this.filter[type.field + '_end']).isAfter(moment(obj[type.field])))) {
                      result = false
                    }
                  }
                  break
                case 'date':
                  if (this.filter[type.field + '_period'] === 'Diária') {
                    if (!obj[type.field] || moment(obj[type.field]).isAfter(now.endOf('day')) || moment(obj[type.field]).isBefore(now.startOf('day'))) {
                      result = false
                    }
                  } else if (this.filter[type.field + '_period'] === 'Semanal') {
                    if (!obj[type.field] || moment(obj[type.field]).isAfter(now.endOf('week')) || moment(obj[type.field]).isBefore(now.startOf('week'))) {
                      result = false
                    }
                  } else if (this.filter[type.field + '_period'] === 'Mensal') {
                    if (!obj[type.field] || moment(obj[type.field]).isAfter(now.endOf('month')) || moment(obj[type.field]).isBefore(now.startOf('month'))) {
                      result = false
                    }
                  } else {
                    if ((this.filter[type.field + '_begin'] && (this.filter[type.field + '_begin'] !== '') && !(moment(obj[type.field]).isAfter(moment(this.filter[type.field + '_begin']))))) {
                      result = false
                    }
                    if (this.filter[type.field + '_end'] && (this.filter[type.field + '_end'] !== '') && !(moment(obj[type.field]).isAfter(moment(this.filter[type.field + '_begin'])))) {
                      result = false
                    }
                  }
                  break
                case 'array':
                  // Quando é necessario ver os valores que estão dentro de outros valores usa o secon_field
                  let objField = ''
                  if (type.many_field) {
                    type.many_field.map((field, i) => {
                      // Caso o registro seja o primeiro verifica se existe, pois se não existir recebe zero, para entrar no filtro de "Vazio"
                      if (i === 0) {
                        objField = !obj[field] ? 0 : obj[field]
                      } else {
                        // caso o registro seja o segundo pra frente, o objField vai concatenando com um _ para formar o id composto.
                        // Inserido o null pois, vazio tranforma o objField em string e quando compara com 0 deve ser integer
                        objField += !obj[field] ? null : '_' + obj[field]
                      }
                    })
                  } else if (type.second_field) {
                    objField = !obj[type.field] ? 0 : obj[type.field][type.second_field]
                  } else {
                    objField = !obj[type.field] ? 0 : obj[type.field]
                  }
                  if (this.filter[type.field] && (this.filter[type.field] !== '') && (this.filter[type.field].length > 0)) {
                    if (this.filter[type.field].includes('allLess')) {
                      if ((type['optionAllLess'].includes(objField))) {
                        result = false
                      }
                      this.filter[type.field] = ['allLess']
                    } else if (!(this.filter[type.field].includes(objField))) {
                      result = false
                    }
                  }
                  break
                case 'boolean':
                  // '!!' no obj[type.field] é usado para converter para boolean
                  if (this.filter[type.field] && (this.filter[type.field] !== '') && !(!!obj[type.field] === this.filter[type.field])) {
                    result = false
                  }
                  break
              }
            })
            return result
          })
        }
        // setInterval usado para controlar quando os valores foram carregados do banco para uso
        let itemsLoadedInterval = setInterval(() => {
          if (this.filterItensLoaded) {
            // So verifica se tem o valor a primeira vez, pois depois que a tela já estiver carregada não tem necessidade já que o LocalFilterType so é atualizado quando atualiza a pagina
            if (this.firstTime) {
              this.verifyHasValue(postFilter, items)
            }
            // Chama a função mountChips para inserir os chips e informar para o usuario os filtros que foram selecionados
            this.mountChips()
            clearInterval(itemsLoadedInterval)
          }
        }, 300)
        // Manda os items já filtrados para o pai.
        this.dialogFilter = false
        if (postFilter) {
          // Modifica o filtro padrão do usuario
          this.changeUserFilter()
        }
        this.$emit('customFilter', filteredItems)
      },
      changeUserFilter () {
        // É usado um get para buscar o user pois this.$auth.user() não busca atualizado
        this.userFilter = this.$store.getters[`filter/values`]
        this.userFilter[this.entity] = this.filter
        this.$store.commit('filter/change_values', this.userFilter)
        this.$http.post('auth/change-filter', {'filter': JSON.stringify(this.filter), 'entity': this.entity}).then((res) => {
          this.$emit('afterChangeUserFilter', this.filter)
        })
      },
      verifyHasValue (postFilter, items) {
        this.firstTime = false
        // Usado para preencher o localFilterType quando os dados dos campos são carregados
        this.reloadLocalFilterType()
        let refresh = false
        // Verifica se todos os itens filtrados(do filtro do usuário) realmente existe, caso algum não exista, ele será removido do filtro do usuário
        for (var index in this.filter) {
          let itemsType = []
          let type = this.localFilterType.find((res) => {
            return ((res.type === 'array') && (res.field === index))
          })
          if (type && type.items) {
            itemsType = type.items.map(function (a) {
              return (typeof type.value !== 'undefined') ? a[type.value] : a['value']
            })
            // filterIndex armazena os valores filtrados referente aquele campo de array
            let filterIndex = Array.from(this.filter[index]) || []
            filterIndex.forEach((val) => {
              if (!itemsType.includes(val)) {
                // Se existir apenas um valor o qual será retirado da lista por não existir mais seta o refresh para true
                this.filter[type.field].splice(this.filter[type.field].indexOf(val), 1)
                if (itemsType.length === 1) {
                  refresh = true
                }
              }
            })
          }
          // Se o refresh for true, faz o custom novamente em vista que devido o filtro estar com valores que não existem foi filtrado so pelo valor dele
          if (refresh) {
            this.customFilter(items, postFilter, this.doFilter)
          }
        }
      },
      close () {
        this.dialogFilter = false
        this.filter = JSON.parse(JSON.stringify(this.oldFilter))
      },
      reloadLocalFilterType () {
        // É usado o localFilterType para poder adicionar os valores vazios, pois sem essa variável acaba adicionando nas lsitas do componente pai
        this.localFilterType = JSON.parse(JSON.stringify(this.filterTypes))
        // É feito um forEach nos localFilterType para inserrir um valor 0, o qual é responsável por permitir o usuário selecionar uma opção com os registros vazios
        this.localFilterType.forEach((type) => {
          if (type.items && type.type === 'array') {
            if (type['not_empty'] !== true) {
              let nullValue = '{"' + (type.value || 'value') + '": 0, "' + (type.text || 'text') + '": "' + (type['field'] === 'status' ? 'Sem Status' : 'Vazio') + '"}'
              type.items.unshift(JSON.parse(nullValue))
            }

            if (type.optionAllLess) {
              let allLess = '{"' + (type.value || 'value') + '": "allLess", "' + (type.text || 'text') + '": "Todas menos Finalizadas"}'
              type.items.unshift(JSON.parse(allLess))
            }
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/shared/PFilter.vue